<template>
  <div>
    <el-upload
      class='avatar-uploader'
      action='/mall/fileUpload.htm'
      :show-file-list='false'
      :on-success='handleAvatarSuccess'
      :before-upload='beforeAvatarUpload'
    >
      <img v-if='imgurl' :src='imgurl' class='avatar' />
      <i v-else class='el-icon-plus avatar-uploader-icon'></i>
    </el-upload>
    <ol v-if='w||h' class='index-image-tip'>
      <li v-if='w'>每张宽度要求{{w}}像素，所有图片宽度一致；</li>
      <li v-if='h'>每张高度小于等于{{h}}像素；</li>
      <li>每张图片容量应小于等于{{size}}；</li>
      <li>图片格式为：{{type}} ；</li>
      <li>为了更好的视觉呈现，图片上的文字字号建议不小于20号</li>
    </ol>
  </div>
</template>

<script>
export default {
  name: "Upload",
  props: {
    imgurl: {
      type: String,
      default: ""
    },
    type: {
      type: String,
      default: `JPG\\JPEG\\PNG `
    },
    size: {
      type: String, //传入的类型
      default: "1024KB" //这样可以指定默认的值
    },
    w: {
      type: [String, Number]
    },
    h: {
      type: [String, Number]
    }
  },
  methods: {
    handleAvatarSuccess(res, file) {
      this.$emit("update:imgurl", res.data);
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    }
  }
};
</script>

<style lang="scss" scoped>
.avatar-uploader /deep/ .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader /deep/ .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
.index-image-tip {
  color: #aaa;
  padding: 0;
  font-size: 13px;
  line-height: 20px;
}
</style>